module.exports = __webpack_public_path__ + "static/media/International_travel_controls_timeline.f6a372ac.svg";